import { createStore, combineReducers, applyMiddleware, Middleware } from "redux"
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { systemReducer } from "./system/reducers"
import { UserReducer } from "./user/reducers";

const rootReducer = combineReducers({
  system: systemReducer,
  userAction: UserReducer
});
export type AppState = ReturnType<typeof rootReducer>;
export default function configureStore() {
  const middlewares: Middleware[] = [thunkMiddleware]; 
  const middleWareEnhancer = applyMiddleware(...middlewares);
  const store = createStore(
    rootReducer,
    composeWithDevTools(middleWareEnhancer)
  );
  return store;
}

